import React from "react";
import { Link, useNavigate } from "react-router-dom";
// import { SearchSvg } from "../../svgFile";
import { defaultConfig } from "../../config";
import AllMenu from "../common/AllMenu";
import { usePage } from "../../PageContext";

const Header = ({count=0}) => {
  const token = localStorage.getItem("accessToken");
  const user = JSON.parse(localStorage.getItem("userData"));

  const navigate = useNavigate();
  const handleProfileClick = () => {
    if (token) {
      navigate("/myprofile");
    }
  };
  const { profilePhoto } = usePage();
  return (

    <header className="d-xl-none d-block">
      <nav className="navbar navbar-expand-xl ">
        <div className="container ">
          <div className="d-flex align-items-center gap-3 home-profile">
            <img
              src={
                profilePhoto
                  ? defaultConfig.Userimage + profilePhoto
                  : "/image/profile.svg"
              }
              alt=""
              style={{ cursor: "pointer" }}
              onClick={handleProfileClick}
            />
            <div className="h-profile-content">
              <p className="mb-0">Welcome</p>
              {token ? (
                <h3>{user?.full_name}</h3>
              ) : (
                <h3>
                  <span>
                    <Link to="/signin">Login</Link>
                  </span>
                  /
                  <span>
                    <Link to="/signup">SignUp</Link>
                  </span>
                </h3>
              )}
            </div>
          </div>
          <div className="d-flex align-items-center gap-2">
            <button
              className="navbar-toggler toggler-btn"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#mainMenu"
              aria-controls="mainMenu"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            {token &&<button className="navbar-toggler toggler-btn position-relative" onClick={(()=> navigate("/notification"))}>
              <img src="/image/bell.svg" alt="" />
              <div className="notification-dot">{count}</div>
            </button> }
          </div>
          <AllMenu count={count}/>
        </div>
      </nav>
      {/* <div className="container">
        <div className="search-wrapper my-2 d-block d-xl-none">
          <div className="form-group position-relative">
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
            />
            <div className="search-icon">
              <SearchSvg />
            </div>
          </div>
        </div>
      </div> */}
      <div className="shape"></div>
    </header>
  );
};

export default Header;
